import { IntlProvider } from 'react-intl';
import Authentication from 'src/Components/Auth/Authentication';
import './App.css';
import { useQuery } from '@apollo/client';
import { loadLocaleMessages, selectValidLocale } from 'src/lang/locales';
import PageRoutes from 'src/Components/Pages/PageRoutes';
import GET_LOCALE from './graphql/queries/intlQuery';
import env from './env';

const App = () => {
    const { data: localeData } = useQuery(GET_LOCALE);

    return (
        <Authentication>
            <IntlProvider
                key={localeData.appLocale}
                locale={selectValidLocale(localeData.appLocale)}
                messages={loadLocaleMessages(localeData.appLocale)}
                defaultLocale={env.defaultLocale}
            >
                <PageRoutes />
            </IntlProvider>
        </Authentication>
    );
};

export default App;